import { Skeleton } from '@mui/material';

const ContentLoadingSkeleton = () => {
  return (
    <div className='flex h-full w-full flex-col'>
      {Array.from({ length: 4 }).map((_, i) => {
        return <Skeleton key={i} component='div' variant='rounded' sx={{ margin: '30px', height: '25%' }} />;
      })}
    </div>
  );
};

export default ContentLoadingSkeleton;
